import { SortedMap } from '@rimbu/sorted/map';
import { TableContext, } from '@rimbu/table/custom';
function createContext(options) {
    return Object.freeze(new TableContext('SortedTableSortedColumn', options?.rowContext ?? SortedMap.defaultContext(), options?.columnContext ?? SortedMap.defaultContext()));
}
const _defaultContext = createContext();
export const SortedTableSortedColumn = Object.freeze({
    ..._defaultContext,
    createContext,
    defaultContext() {
        return _defaultContext;
    },
});
//# sourceMappingURL=interface.mjs.map